import { Chip, IconButton } from "@mui/material";
import { FC } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { CourseFilter } from "../../../services/type";
import PersonIcon from '@mui/icons-material/Person';
import { useSearchParams } from "react-router-dom";


type Props = {
    keyFilter: keyof CourseFilter;
    label: string;
};

const ChipResult: FC<Props> = ({ label, keyFilter }) => {
    const [searchParam, setSearchParams] = useSearchParams();
    const handleDelete = () => {
        const params = new URLSearchParams(searchParam);
        params.delete(keyFilter)
        setSearchParams(params, { replace: true });
    }

    return <Chip
        component={"span"}
        label={label}
        variant="filled"
        sx={{
            display: "flex",
            alignItems: "center",
            height: 26,
            fontSize: 11,
            fontWeight: 700,
            borderRadius: '8px',
            bgcolor: 'secondary.main',
            color: 'white',
            '& .MuiChip-icon': {
                color: 'white',
            },
            '& .MuiChip-deleteIcon': {
                color: 'white',
                opacity: 0.8,
                '&:hover': {
                    opacity: 1,
                },
            },
        }}
        icon={
            (keyFilter === 'minParticipant' || keyFilter === 'maxParticipant') ? (
                <PersonIcon sx={{ fontSize: 16 }} />
            ) : undefined
        }
        deleteIcon={< IconButton disableRipple > <CloseIcon sx={{ color: "white" }} /> </IconButton >}
        onDelete={handleDelete}
    />
}



export default ChipResult